module.exports = __webpack_public_path__ + "img/6.48145bb4.svg";